import styled from 'styled-components';
import ontarioLogo from '../assets/ontario-logo.svg';
import breakpoint from '~/utils/style-utils';

const TermsContainer = styled.div`
	background-color: #41444f;
	display: inline-block;

	${breakpoint.lg`
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;
	`};
`;

const LogoContainer = styled.div`
	display: inline-block;
	float: left;
	margin-left: 6px;
	margin-top: 12px;
	margin-right: 6px;

	${breakpoint.lg`
		float: auto;
		margin-left: 24px;
		margin-top: 0;
		margin-right: 0;
	`};
`;

const LogoImage = styled.img`
	width: 90px;
	height: 24px;

	${breakpoint.lg`
		width: 120px;
		height: 48px;
	`};
`;

const TermsText = styled.p`
	padding: 12px;
	padding-left: 12px;
	color: var(--bannerTermsConditionsColor);
	font: var(--bannerTermsConditionsFont);

	${breakpoint.lg`
		padding: 24px;
		padding-left: 14px;
	`};
`;

const OntarioTerms = ({ text }) => {
	return (
		<TermsContainer>
			<LogoContainer>
				<LogoImage src={ontarioLogo} />
			</LogoContainer>
			<TermsText>{text}</TermsText>
		</TermsContainer>
	);
};

export default OntarioTerms;
